export const hasErrors = (errors: Record<string, string>): boolean => {
    return Object.values(errors).some((error) => error !== '');
};
